export const INSURANCES_SET_LOADING = 'INSURANCES/SET_LOADING';
export const INSURANCES_SET_ERROR = 'INSURANCES/SET_ERROR';
export const INSURANCES_SET_INSURANCES = 'INSURANCES/SET_INSURANCES';
export const INSURANCES_SET_PAGINATION = 'INSURANCES/SET_PAGINATION';

export const INSURANCES_FETCH_INSURANCES = 'INSURANCES/FETCH_INSURANCES';
export const INSURANCES_CLEAR_ERROR = 'INSURANCES/CLEAR_ERROR';

export const INSURANCES_GET_INSURANCES = 'INSURANCES/GET_INSURANCES';
export const INSURANCES_GET_PAGINATION = 'INSURANCES/GET_PAGINATION';
export const INSURANCES_GET_LOADING = 'INSURANCES/GET_LOADING';
export const INSURANCES_GET_ERROR = 'INSURANCES/GET_ERROR';
